import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'bibliotheque',

  type : 'module',
  
  label: 'Bibliothèque d\'image et docs',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-image-album',
  }
}